/*
 * QQQ - Low-code Application Framework for Engineers.
 * Copyright (C) 2021-2026.  Kingsrook, LLC
 * 651 N Broad St Ste 205 # 6917 | Middletown DE 19709 | United States
 * contact@kingsrook.com
 * https://github.com/Kingsrook/
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */


import React, {Component} from "react";

interface PreviewErrorBoundaryProps
{
   children: React.ReactNode;
}

interface PreviewErrorBoundaryState
{
   hasError: boolean;
}


/*******************************************************************************
 ** stored entries are never checked against current metadata, so rendering a
 ** filter preview can throw (e.g. a criterion on a field that was since removed).
 ** Catch that per row and fall back to "No filter", so one bad entry can't take
 ** down the screen.
 *******************************************************************************/
export default class QueryHistoryPreviewErrorBoundary extends Component<PreviewErrorBoundaryProps, PreviewErrorBoundaryState>
{
   state: PreviewErrorBoundaryState = {hasError: false};

   /***************************************************************************
    **
    ***************************************************************************/
   static getDerivedStateFromError(): PreviewErrorBoundaryState
   {
      return ({hasError: true});
   }

   /***************************************************************************
    **
    ***************************************************************************/
   componentDidCatch(error: Error)
   {
      console.log("Error rendering a query history filter preview", error);
   }

   /***************************************************************************
    **
    ***************************************************************************/
   render(): React.ReactNode
   {
      return (this.state.hasError ? <i>No filter</i> : this.props.children);
   }
}
